const aaa = [
	{
		path: "shuju",
		component: () => import("@/views/shuju/shuju.vue"),
		meta:{title:'门店数据1'},
	},
	{
		path: "mendianshuju",
		component: () => import("@/views/shuju/mendianshuju.vue"),
		meta:{title:'门店数据'},
	},
	
]
export default aaa;